import { useLocation } from "react-router";
import { useEffect, FunctionComponent } from "react";
import { createPageview } from "@lib/analytics";

/**
 * Tracks the page changes and sends it to the analytics service.
 */
const PageAnalytics: FunctionComponent = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    createPageview(pathname);
  }, [pathname]);

  return null;
};

export { PageAnalytics };
